import { put, call, takeEvery } from "redux-saga/effects"
import { Logger } from "@ng-mw/shared-react-components"
import { getFullLocalUrl } from "@app/helpers/useAppContent"
import { actions } from "@app/store/settings/settingsActions"
import { SettingsActionTypes, InfoBannerApiResponse } from "@app/store/settings/types"

export function* loadInfoBanner() {
    const url = getFullLocalUrl("/api/app/common/info-banner")

    try {
        Logger.debug("loadInfoBanner()", { url })
    } catch {}

    try {
        const response: Response = yield call(fetch, url)
        if (!response.ok) {
            yield put(actions.infoBannerError(response.statusText))
            return
        }

        const infoBanner: InfoBannerApiResponse = yield call([response, response.json])
        yield put(actions.infoBannerSuccess(infoBanner))
    } catch (error: any) {
        yield put(actions.infoBannerError(error))
        try {
            Logger?.error?.("loadInfoBanner()", { error })
        } catch {}
    } finally {
        yield put(actions.infoBannerLoaded())
    }
}

export default function* infoBannerSaga() {
    yield takeEvery(SettingsActionTypes.InfoBannerLoading, loadInfoBanner)
}
